import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, Type, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldTypeConfig, FieldWrapper, FormlyFieldConfig, FormlyFieldProps, FormlyModule } from '@ngx-formly/core';
import { MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgFor, NgIf } from '@angular/common';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { FormlyFieldInput } from '@ngx-formly/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';

interface InputProps extends FormlyFieldProps {}

export interface FormlyInputFieldConfig extends FormlyFieldConfig<InputProps> {
  type: 'input' | Type<FormlyFieldInput>;
}

@Component({
    selector: 'formly-star-rating',
    template: `

<button class="white-icon" mat-icon-button [color]="'color'" *ngFor="let ratingId of ratingArr;index as i" [id]="'star_'+i" (click)="onClick(i+1)" [matTooltip]="ratingId+1" matTooltipPosition="above">
  <mat-icon>
    {{showIcon(i)}}
  </mat-icon>
</button>
<input #ratingInput [id]="id" [name]="field.name" type="hidden" [formControl]="formControl" [formlyAttributes]="field" />
<mat-error *ngIf="starCount == null || starCount == 0">
  Il voto è  <strong>obbligatorio</strong>
</mat-error>
<p class="body-2">
    Hai votato <span class="body-2">{{rating||0}}</span> / <span class="body-2">{{starCount}}</span>
</p>

    `,
    styles:[`.white-icon { color: white; }`],
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ FormlyModule, MatIconModule, MatProgressSpinnerModule, NgIf, NgFor, ReactiveFormsModule, MatTooltipModule ]
})
export class StarRatingTypeComponent extends FieldType<FieldTypeConfig<InputProps>>{

    rating: number = 5;
    starCount: number = 5;
    color: string = 'warn'
    disabled: boolean = false;
    private snackBarDuration: number = 2000;
    ratingArr = [];

    constructor(private snackBar: MatSnackBar) {
        super()
    }

    ngOnInit() {
        this.rating = this.field.formControl.value;
        for (let index = 0; index < this.starCount; index++) {
          this.ratingArr.push(index);
        }
      }
      onClick(rating:number) {

        if(this.disabled){
          return
        }

        this.snackBar.open('Hai votato ' + rating + ' / ' + this.starCount, '', {
          duration: this.snackBarDuration
        });
        this.field.formControl.setValue(rating)
        this.rating = rating;
        return false;
      }

      showIcon(index:number) {
        if (this.rating >= index +1 ) {
          return 'star';
        } else {
          return 'star_border';
        }
      }


}
